var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"wrap":"","dense":""}},_vm._l((_vm.items),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"4"}},[_c('Cell',{attrs:{"item":item,"eventId":_vm.eventId},on:{"click":function($event){return _vm.$emit('select', item._id)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }